// extracted by mini-css-extract-plugin
export default {"button":"css_button__5JWpF","icon":"css_icon__ORTO8","text":"css_text__kqs1W"};